import { tourStep } from './tourRegistry';

export const bandaEventosSteps = [
  tourStep(
    'eventos-header',
    'Eventos con cofradías',
    'Aquí ves los cultos y procesiones en los que participáis. No es el calendario interno de actuaciones: eso está en Gestión.',
  ),
  tourStep(
    'eventos-resumen',
    'Resumen',
    'Total, confirmados y ya celebrados. Sirve para ver de un vistazo cómo va la temporada.',
  ),
  tourStep(
    'eventos-tabs',
    'Próximos, pasados y cancelados',
    'Cambia de lista para seguir lo que queda, revisar lo hecho o ver lo que se anuló.',
    'bottom',
  ),
];
